export class Link {
	constructor(
		public name: string,
		public link: string,
		public icon: string
	) {}
}
